import React from 'react'
import MainLayout from '@layouts/main-layout'
import TermsAndConditions from '@components/footer/terms-and-conditions'

const TermsAndConditionsPage = () => {
  return (
    <>
      <TermsAndConditions />
    </>
  )
}

TermsAndConditionsPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default TermsAndConditionsPage
